<template>
	<v-container fluid>
		<v-row class="px-3">
			<v-col cols="6">
				<div
					class="module-top-info"
					v-if="branch.id != null && branch.id != undefined && branch.id !== 0 && branch.id !== '0'"
				>
					<span class="module-top-name">{{ branch.name }}</span>
					<span v-if="branch.status_id != null && branch.status_id != undefined" class="member-top-status"
						>Status: <b>{{ branch.branch_status.name }}</b></span
					>
				</div>
				<div v-else>
					<span class="module-top-name" v-if="branch.branch_type_id == 1">{{
						$t('labels.branchNewDepartment')
					}}</span>
					<span class="module-top-name" v-if="branch.branch_type_id == 2">{{
						$t('labels.branchNewBranch')
					}}</span>
					<span class="module-top-name" v-if="branch.branch_type_id == 3">{{
						$t('labels.branchNewHeadquarters')
					}}</span>
				</div>
			</v-col>
			<v-col cols="6" class="d-flex justify-end">
				<v-btn
					v-if="branch.id != null && branch.id != 0 && inEditMode === false"
					class="mr-3"
					color="primary"
					@click="inEditMode = true"
					>Uredi</v-btn
				>
				<v-btn v-else class="mr-3" color="primary" @click="saveClick">Spremi</v-btn>
				<v-btn v-if="inEditMode === false || branch.id == '0'" @click="backClick">Natrag</v-btn>
				<v-btn v-else @click="cancelEditClick">Odustani</v-btn>
			</v-col>
		</v-row>
		<v-row>
			<v-tabs left color="primary" v-model="tabId">
				<v-tab class="module-tab"> {{ $t('tabs.branchInfo') }} </v-tab>
				<v-tab class="module-tab"> {{ $t('tabs.branchWork') }} </v-tab>
				<v-tab
					class="module-tab"
					:disabled="
						branch.id != null && branch.id != undefined && branch.id !== 0 && branch.id !== '0'
							? false
							: true
					"
				>
					{{ $t('tabs.branchMembers') }}
				</v-tab>
				<v-tab
					class="module-tab"
					:disabled="
						branch.id != null && branch.id != undefined && branch.id !== 0 && branch.id !== '0'
							? false
							: true
					"
				>
					{{ $t('tabs.branchHistory') }}
				</v-tab>
				<v-tab-item>
					<v-row class="pl-2 pl-md-0 pt-2 ml-0">
						<span class="module-title"> Osnovni podaci </span>
					</v-row>
					<v-row class="px-3 pt-3">
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:readonly="!inEditMode"
									v-model="branch.name"
									:label="'*' + $t('fields.name')"
									:errorBorder="!branchValidation.name"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:clearable="inEditMode"
									:readonly="!inEditMode"
									v-model="branch.status_id"
									:ajax="true"
									:data="'branch-statuses'"
									:label="'* ' + $t('fields.status')"
									:errorBorder="!branchValidation.status_id"
								></Dropdown>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<InputField
									:readonly="!inEditMode"
									v-model="branch.oib"
									:label="$t('fields.oib')"
								></InputField>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<InputField
									:readonly="!inEditMode"
									v-model="branch.registry_number"
									:label="$t('fields.registryNumber')"
								></InputField>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<InputField
									:readonly="!inEditMode"
									v-model="branch.address"
									:label="'*' + $t('fields.address')"
									:errorBorder="!branchValidation.address"
								></InputField>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<InputField
									:readonly="!inEditMode"
									v-model="branch.zip_code"
									:label="$t('fields.zipCode')"
								></InputField>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<InputField
									:readonly="!inEditMode"
									v-model="branch.headquarters"
									:label="$t('fields.headquarters')"
								></InputField>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="
									(branch.branch_type_id == 2 || branch.branch_type_id == 3) && countrySelectedCroatia
								"
							>
								<Dropdown
									:readonly="!inEditMode"
									v-model="branch.county_id"
									:ajax="true"
									:data="'counties'"
									:label="$t('fields.county')"
								></Dropdown>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<Dropdown
									:readonly="!inEditMode"
									v-model="branch.country_id"
									:ajax="true"
									:data="'countries'"
									:label="$t('fields.country')"
								></Dropdown>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<InputField
									:readonly="!inEditMode"
									v-model="branch.iban"
									:label="$t('fields.iban')"
								></InputField>
							</v-row>
						</v-col>
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<DatePicker
									:readonly="!inEditMode"
									v-model="branch.registry_entry_date"
									:dateLabel="$t('fields.registryEntryDate')"
								></DatePicker>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<DatePicker
									:readonly="!inEditMode"
									v-model="branch.founding_assembly_date"
									:dateLabel="$t('fields.foundingAssemblyDate')"
								></DatePicker>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<DatePicker
									:readonly="!inEditMode"
									v-model="branch.master_assembly_date"
									:dateLabel="$t('fields.masterAssemblyDate')"
									:errorBorder="!branchValidation.master_assembly_date"
								></DatePicker>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<DatePicker
									:readonly="!inEditMode"
									v-model="branch.last_assembly_date"
									:dateLabel="$t('fields.lastAssemblyDate')"
								></DatePicker>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:readonly="!inEditMode"
									v-model="branch.record_link"
									:label="$t('fields.recordLink')"
								></InputField>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<InputField
									:readonly="!inEditMode"
									v-model="branch.delivered_rulebook"
									:label="$t('fields.deliveredRulebook')"
								></InputField>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<v-radio-group
									row
									dense
									class="mt-1"
									:readonly="!inEditMode"
									v-model="branch.rulebook_confirmed"
									:label="$t('fields.rulebookConfirmed')"
								>
									<v-radio label="Da" :value="true"></v-radio>
									<v-radio label="Ne" :value="false"></v-radio>
								</v-radio-group>
							</v-row>
						</v-col>
					</v-row>
					<v-row class="pl-2 pl-md-0 pt-2 ml-0">
						<span class="module-title"> Vodstvo </span>
					</v-row>
					<v-row class="px-3 pt-3">
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<Dropdown
									:clearable="inEditMode"
									:readonly="!inEditMode"
									v-model="branch.president_id"
									:ajax="true"
									:data="'voting-members'"
									:label="$t('fields.president')"
									:errorBorder="!branchValidation.president_id"
								></Dropdown>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<InputField
									:readonly="!inEditMode"
									v-model="branch.president_confirmation"
									:label="$t('fields.presidentConfirmation')"
									:errorBorder="!branchValidation.president_confirmation"
								></InputField>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 1"
							>
								<Dropdown
									:clearable="inEditMode"
									:readonly="!inEditMode"
									v-model="branch.head_id"
									:ajax="true"
									:data="'voting-members'"
									:label="$t('fields.head')"
									:errorBorder="!branchValidation.head_id"
								></Dropdown>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 1"
							>
								<InputField
									:readonly="!inEditMode"
									v-model="branch.head_confirmation"
									:label="$t('fields.headConfirmation')"
									:errorBorder="!branchValidation.head_confirmation"
								></InputField>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2 || branch.branch_type_id == 3"
							>
								<DropdownMultiple
									:clearable="inEditMode"
									:readonly="!inEditMode"
									v-model="branch.vice_president_ids"
									:ajax="true"
									:data="'voting-members'"
									:label="$t('fields.vicePresidents')"
									:errorBorder="!branchValidation.vice_president_ids"
								></DropdownMultiple>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:clearable="inEditMode"
									:readonly="!inEditMode"
									v-model="branch.secretary_id"
									:ajax="true"
									:data="'voting-members'"
									:label="$t('fields.secretary')"
									:errorBorder="!branchValidation.secretary_id"
								></Dropdown>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 3"
							>
								<Dropdown
									:clearable="inEditMode"
									:readonly="!inEditMode"
									v-model="branch.board_member_id"
									:ajax="true"
									:data="'voting-members'"
									:label="$t('fields.boardMember')"
									:errorBorder="!branchValidation.board_member_id"
								></Dropdown>
							</v-row>
						</v-col>
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 3"
							>
								<Dropdown
									:clearable="inEditMode"
									:readonly="!inEditMode"
									v-model="branch.literary_secretary_id"
									:ajax="true"
									:data="'voting-members'"
									:label="$t('fields.literarySecretary')"
									:errorBorder="!branchValidation.literary_secretary_id"
								></Dropdown>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 3"
							>
								<Dropdown
									:clearable="inEditMode"
									:readonly="!inEditMode"
									v-model="branch.economic_secretary_id"
									:ajax="true"
									:data="'voting-members'"
									:label="$t('fields.economicSecretary')"
									:errorBorder="!branchValidation.economic_secretary_id"
								></Dropdown>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<DatePicker
									:readonly="!inEditMode"
									v-model="branch.mandate_expiration_date"
									:dateLabel="$t('fields.mandateExpirationDate')"
									:errorBorder="!branchValidation.mandate_expiration_date || expirationDatePassed"
								></DatePicker>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<TextArea
									:readonly="!inEditMode"
									v-model="branch.note"
									:label="$t('fields.note')"
									:rows="3"
								></TextArea>
							</v-row>
						</v-col>
					</v-row>
					<v-row class="pl-2 pl-md-0 pt-2 ml-0">
						<span class="module-title"> Kontakt </span>
					</v-row>
					<v-row class="px-3 pt-3">
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:readonly="!inEditMode"
									v-model="branch.phone_number"
									:label="$t('fields.phoneNumber')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:readonly="!inEditMode"
									v-model="branch.mobile_phone_number"
									:label="$t('fields.mobilePhoneNumber')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:readonly="!inEditMode"
									v-model="branch.email"
									:label="$t('fields.email')"
								></InputField>
							</v-row>
						</v-col>
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2"
							>
								<InputField
									:readonly="!inEditMode"
									v-model="branch.facebook"
									:label="$t('fields.facebook')"
								></InputField>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								:class="!inEditMode ? 'read-only-class' : ''"
								v-if="branch.branch_type_id == 2"
							>
								<InputField
									:readonly="!inEditMode"
									v-model="branch.web_site"
									:label="$t('fields.webSite')"
								></InputField>
							</v-row>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item>
					<v-row class="pl-2 pl-md-0 pt-2 ml-0">
						<span class="module-title" v-if="branch.branch_type_id == 1"> Rad Odjela </span>
						<span class="module-title" v-if="branch.branch_type_id == 2"> Rad Ogranka </span>
						<span class="module-title" v-if="branch.branch_type_id == 3"> Rad Središnjice </span>
					</v-row>
					<v-row class="px-3 pt-3">
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:readonly="!inEditMode"
									v-model="branch.activity_report_link"
									:label="$t('fields.activityReportLink')"
								></InputField>
							</v-row>
						</v-col>
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:readonly="!inEditMode"
									v-model="branch.branch_site_link"
									:label="$t('fields.branchSiteLink')"
								></InputField>
							</v-row>
						</v-col>
					</v-row>
					<v-row
						class="pl-2 pl-md-0 pt-2 ml-0"
						v-if="branch.id != null && branch.id != 0 && branch.id != '0'"
					>
						<span class="module-title"> Korespondencija </span>
					</v-row>
					<v-row class="px-3 pt-3" v-if="branch.id != null && branch.id != 0 && branch.id != '0'">
						<v-col cols="12" class="px-md-5 py-0">
							<div class="correspondence-container">
								<div v-for="entry in communication" :key="entry.id" class="correspondence-message">
									<div class="message-details">
										<span class="message-author"
											>{{ entry.author.first_name }}&nbsp;{{ entry.author.last_name }}</span
										>
										<span class="message-date">{{ entry.created_at }}</span>
									</div>
									<div class="message-content">
										{{ entry.content }}
									</div>
								</div>
							</div>
							<div class="new-message-container">
								<v-row class="px-3">
									<v-col cols="11" class="ma-0 pr-2 pa-0">
										<InputField
											v-model="newMessage"
											:label="$t('fields.newMessage')"
											@keyup.native.enter="sendMessage"
										>
										</InputField>
									</v-col>
									<v-col cols="1" class="ma-0 pa-0 d-flex justify-end">
										<v-btn @click="sendMessage" color="primary">Pošalji</v-btn>
									</v-col>
								</v-row>
							</div>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item>
					<v-row class="pa-4">
						<v-col cols="12">
							<v-card flat outlined>
								<v-card-text>
									<v-row>
										<v-col>
											<TheTable
												:additional-filters="membersTable.additionalFilters"
												:default-sort="membersTable.defaultSort"
												:fields="membersTable.headers"
												:filter-save-key="'branch-members-filters'"
												:height="membersTable.height"
												:total-records="membersTable.total"
												@headers="selectMembersHeaders"
												@reload="reloadMembersData"
												:excel="true"
												@excel="membersExcelExport"
											>
												<tr
													v-for="(item, key) in membersTable.items"
													:key="key"
													:class="{ 'cursor-pointer': true }"
													@contextmenu.prevent="editMemberClick(props.item.id, true)"
												>
													<td
														v-if="membersTable.selectedHeaders.includes('full_name')"
														@click="editMemberClick(item.id, false)"
													>
														<span v-if="item.full_name != null">{{ item.full_name }}</span>
														<span v-else>-</span>
													</td>
													<td
														v-if="membersTable.selectedHeaders.includes('email')"
														@click="editMemberClick(item.id, false)"
													>
														<span v-if="item.email != null">{{ item.email }}</span>
														<span v-else>-</span>
													</td>
													<td
														v-if="membersTable.selectedHeaders.includes('phone_number')"
														@click="editMemberClick(item.id, false)"
													>
														<span v-if="item.phone_number != null">{{
															item.phone_number
														}}</span>
														<span v-else>-</span>
													</td>
													<td
														v-if="membersTable.selectedHeaders.includes('city')"
														@click="editMemberClick(item.id, false)"
													>
														<span v-if="item.city != null">{{ item.city }}</span>
														<span v-else>-</span>
													</td>
													<td
														v-if="membersTable.selectedHeaders.includes('address')"
														@click="editMemberClick(item.id, false)"
													>
														{{ item.address }}
													</td>
													<td
														v-if="membersTable.selectedHeaders.includes('magazine_id')"
														@click="editMemberClick(item.id, false)"
													>
														<span v-if="item.magazine != null">{{
															item.magazine.name
														}}</span>
														<span v-else>-</span>
													</td>
													<td
														v-if="
															membersTable.selectedHeaders.includes('magazine_delivery')
														"
														@click="editMemberClick(item.id, false)"
													>
														<span v-if="item.magazine_delivery != null">{{
															item.magazine_delivery
														}}</span>
														<span v-else>-</span>
													</td>
												</tr>
											</TheTable>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item>
					<v-row class="pa-4">
						<v-col cols="12">
							<v-card flat outlined>
								<v-card-text>
									<v-row>
										<v-col>
											<TheTable
												:additional-filters="branchLogTable.additionalFilters"
												:default-sort="branchLogTable.defaultSort"
												:fields="branchLogTable.headers"
												:filter-save-key="'branch-log-filters'"
												:height="branchLogTable.height"
												:total-records="branchLogTable.total"
												@headers="selectBranchLogHeaders"
												@reload="reloadBranchLogData"
											>
												<tr
													v-for="(item, key) in branchLogTable.items"
													:key="key"
													:class="{ 'cursor-pointer': true }"
													@contextmenu.prevent="editBranchLogClick(props.item.id, true)"
												>
													<td
														v-if="branchLogTable.selectedHeaders.includes('updated_at')"
														@click="editBranchLogClick(item.id, false)"
													>
														<span v-if="item.updated_at != null">{{
															item.updated_at
														}}</span>
														<span v-else>-</span>
													</td>
													<td
														v-if="branchLogTable.selectedHeaders.includes('author')"
														@click="editBranchLogClick(item.id, false)"
													>
														<span v-if="item.author != null">{{ item.author }}</span>
														<span v-else>-</span>
													</td>
													<td
														v-if="branchLogTable.selectedHeaders.includes('field')"
														@click="editBranchLogClick(item.id, false)"
													>
														<span v-if="item.field != null">{{ item.field }}</span>
														<span v-else>-</span>
													</td>
													<td
														v-if="branchLogTable.selectedHeaders.includes('old_value')"
														@click="editBranchLogClick(item.id, false)"
													>
														<span v-if="item.old_value != null">{{ item.old_value }}</span>
														<span v-else>-</span>
													</td>
													<td
														v-if="branchLogTable.selectedHeaders.includes('new_value')"
														@click="editBranchLogClick(item.id, false)"
													>
														<span v-if="item.new_value != null">{{ item.new_value }}</span>
														<span v-else>-</span>
													</td>
												</tr>
											</TheTable>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-tab-item>
			</v-tabs>
		</v-row>
	</v-container>
</template>

<script>
import Branch from '../../../models/Branch';
import Dropdown from '../../trinkets/Dropdown';
import TextArea from '../../trinkets/TextArea';
import TheTable from '../../trinkets/TheTable';
import InputField from '../../trinkets/InputField';
import DatePicker from '@/components/trinkets/DatePicker';
import DropdownMultiple from '../../trinkets/DropdownMultiple';

export default {
	name: 'Branch',
	components: { InputField, Dropdown, TextArea, DatePicker, DropdownMultiple, TheTable },
	data: function () {
		return {
			tabId: 0,
			communication: [],
			newMessage: null,
			inEditMode: false,
			initialLoad: false,
			branch: new Branch({ id: this.$route.params.id }),
			branchValidation: new Branch({}, true),
			membersTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.member'), value: 'full_name', type: 'string', allowFilter: true },
					{ text: this.$t('fields.email'), value: 'email', type: 'string', allowFilter: true },
					{ text: this.$t('fields.phoneNumber'), value: 'phone_number', type: 'string', allowFilter: true },
					{ text: this.$t('fields.city'), value: 'city', type: 'string', allowFilter: true },
					{ text: this.$t('fields.address'), value: 'address', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.magazine'),
						value: 'magazine_id',
						type: '',
						allowFilter: false,
						sortable: false,
					},
					{
						text: this.$t('fields.magazineDelivery'),
						value: 'magazine_delivery',
						type: '',
						allowFilter: false,
						sortable: false,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'last_name',
					descending: true,
				},
			},
			branchLogTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.date'), value: 'updated_at', type: 'date', allowFilter: true },
					{ text: this.$t('fields.person'), value: 'author', type: 'string', allowFilter: true },
					{ text: this.$t('fields.field'), value: 'field', type: 'string', allowFilter: true },
					{ text: this.$t('fields.oldValue'), value: 'old_value', type: 'string', allowFilter: true },
					{ text: this.$t('fields.newValue'), value: 'new_value', type: 'string', allowFilter: true },
				],
				additionalFilters: [
					{
						text: this.$t('fields.date'),
						value: 'updated_at',
						type: 'date_range',
						allowFilter: true,
					},
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'updated_at',
					descending: true,
				},
			},
			countrySelectedCroatia: false,
		};
	},
	computed: {
		expirationDatePassed() {
			if (this.branch.mandate_expiration_date != null && this.branch.mandate_expiration_date != '') {
				let currentDate = new Date();
				let selectedDate = new Date(this.branch.mandate_expiration_date);
				if (currentDate > selectedDate) {
					return true;
				}
			}
			return false;
		},
	},
	watch: {
		'branch.country_id': {
			handler: function (newVal) {
				if (newVal == 1) {
					this.countrySelectedCroatia = true;
				} else {
					this.branch.county_id = null;
					this.countrySelectedCroatia = false;
				}
			},
		},
	},
	methods: {
		cancelEditClick() {
			this.inEditMode = false;
			this.getData();
		},
		editBranchLogClick(id, newTab = false) {
			console.log(id);
		},
		selectBranchLogHeaders(headers) {
			this.branchLogTable.selectedHeaders = headers;
		},
		reloadBranchLogData(request) {
			this.branchLogTable.lastRequest = request;
			request.branch_id = this.branch.id;
			let vm = this;
			this.$APICall(
				'get',
				'branch-log',
				request,
				(data, success) => {
					if (success) {
						vm.branchLogTable.items = data.items;
						vm.branchLogTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		resolveBranchLogWindowResize() {
			this.branchLogTable.height = window.innerHeight - 310 + 'px';
		},
		editMemberClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/members/' + id);
			} else {
				let routeData = this.$router.resolve('/members/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectMembersHeaders(headers) {
			this.membersTable.selectedHeaders = headers;
		},
		reloadMembersData(request) {
			this.membersTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'branch-members/' + this.branch.id,
				request,
				(data, success) => {
					if (success) {
						vm.membersTable.items = data.items;
						vm.membersTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		membersExcelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.membersTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'branch-members/' + this.branch.id,
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/branch-members', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		resolveMembersWindowResize() {
			this.membersTable.height = window.innerHeight - 310 + 'px';
		},
		getData() {
			let vm = this;
			this.$APICall('get', 'branches/' + this.branch.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.branch = usableData;
					vm.$nextTick(() => {
						vm.initialLoad = true;
						vm.$myStore.commit('setBreadcrumbs', [
							{
								text: vm.$t('modules.branches'),
								href: '/#/branches',
								disabled: false,
							},
							{
								text: vm.branch.name,
								href: '/#/branches/' + vm.branch.id,
								disabled: true,
							},
						]);
					});
				} else {
					this.$myStore.commit('setBreadcrumbs', [
						{ text: this.$t('modules.branches'), href: '/#/branches', disabled: false },
					]);
				}
			});
		},
		getCommunication() {
			let vm = this;
			this.$APICall('get', 'branch-communication/' + this.branch.id, {}, (data, success) => {
				if (success) {
					vm.communication = data;
					vm.scrollCorespondance();
				}
			});
		},
		sendMessage() {
			if (this.newMessage != null && this.newMessage.trim() != '') {
				let message = this.newMessage;
				this.$APICall('post', 'branch-new-message/' + this.branch.id, { message }, (data, success) => {
					if (success) {
						this.newMessage = null;
						this.$notify('Poruka poslana');
						this.getCommunication();
					}
				});
			}
		},
		backClick() {
			this.$router.replace('/branches');
		},
		saveClick() {
			let success = true;
			if (this.branch.status_id == null) {
				success = false;
				this.branchValidation.status_id = false;
			} else {
				this.branchValidation.status_id = true;
			}
			if (this.branch.name == null || this.branch.name.trim() == '') {
				success = false;
				this.branchValidation.name = false;
			} else {
				this.branchValidation.name = true;
			}
			if (this.branch.branch_type_id == 2 || this.branch.branch_type_id == 3) {
				if (this.branch.address == null || this.branch.address.trim() == '') {
					success = false;
					this.branchValidation.address = false;
				} else {
					this.branchValidation.address = true;
				}
			}
			if (this.branch.branch_type_id == 3) {
				if (this.branch.literary_secretary_id == null) {
					success = false;
					this.branchValidation.literary_secretary_id = false;
				} else {
					this.branchValidation.literary_secretary_id = true;
				}
				if (this.branch.economic_secretary_id == null) {
					success = false;
					this.branchValidation.economic_secretary_id = false;
				} else {
					this.branchValidation.economic_secretary_id = true;
				}
				if (this.branch.board_member_id == null) {
					success = false;
					this.branchValidation.board_member_id = false;
				} else {
					this.branchValidation.board_member_id = true;
				}
				if (this.branch.master_assembly_date == null || this.branch.master_assembly_date.trim() == '') {
					success = false;
					this.branchValidation.master_assembly_date = false;
				} else {
					this.branchValidation.master_assembly_date = true;
				}
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.branch.id != 0) {
					action = 'put';
					addition = '/' + vm.branch.id;
				}
				this.$APICall(action, 'branches' + addition, this.branch, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.branch.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.backClick();
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			} else {
				this.tabId = 0;
			}
		},
		scrollCorespondance() {
			var correspondanceContainer = document.getElementsByClassName('correspondence-container');
			if (correspondanceContainer != undefined) {
				if (correspondanceContainer[0] != undefined) {
					setTimeout(() => {
						correspondanceContainer[0].scrollTop = 0;
					}, 100);
				}
			}
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.branches'), href: '/#/branches', disabled: false },
		]);
		if (this.branch.id == 0) {
			this.inEditMode = true;
			if (this.$myStore.state.branchTypeId != null && this.$myStore.state.branchTypeId != undefined) {
				this.branch.branch_type_id = this.$myStore.state.branchTypeId;
				this.$myStore.commit('setBranchType', null);
			} else {
				this.branch.branch_type_id = 1;
			}
		} else {
			this.getData();
			this.getCommunication();
			this.resolveMembersWindowResize();
			this.resolveBranchLogWindowResize();
		}
	},
};
</script>

<style>
.correspondence-container {
	height: 400px;
	border: 1px solid gray;
	border-radius: 5px;
	overflow-y: auto;
}
.correspondence-message {
	cursor: default;
	background: rgb(240, 240, 240);
	padding: 3px;
	margin-inline: 1%;
	margin-block: 10px;
	width: 98%;
	border: 1px solid rgb(155, 155, 155);
	border-radius: 3px;
	min-height: 50px;
}

.message-details,
.message-content,
.text-container,
.send-button {
	display: inline-block;
	vertical-align: top;
}

.send-button {
	text-align: center;
	line-height: 107px;
	height: 107px;
	border: 1px solid rgb(111, 111, 111);
	border-radius: 5px;
	width: 17%;
	margin-left: 1%;
	cursor: pointer;
	background: rgb(241, 241, 241);
}

.send-button:hover {
	background: rgb(215, 215, 215);
}

.message-details {
	width: 18%;
}
.message-content,
.text-container {
	width: 82%;
}

.message-author,
.message-date {
	display: block;
}

.message-date {
	font-size: 0.7rem;
	color: rgb(81, 81, 81);
}

.new-message-container {
	margin-top: 10px;
}
</style>
